import { FC, useEffect } from "react";
import Typography from "@mui/material/Typography";
import { getSurveySection } from "app/features/surveySlice";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { FormControlModel } from "types";
import FormComponentFactory from "lib/factory/FormComponentFactory";
import { ElementType } from "lib/enums/enums";
import StepContent from "../StepContent";
import { YES, NO, TRUE, NO_SAVING } from "pages/SurveyForm/constants/uiControls";

type Props = {
  formik: any;
  sectionId: number;
};

const Step16: FC<Props> = ({ formik, sectionId }) => {
  const dispatch = useAppDispatch();
  const { surveySection } = useAppSelector((state) => state.survey) ?? [];
  const { questions = [] } = surveySection || {};

  useEffect(() => {
    dispatch(getSurveySection(sectionId));
  }, []);

  const clearIncomes = (value: string) => {
    if (value === NO) {
      formik.setFieldValue("incomesType", []);
      formik.setFieldValue("incomesAverage", { ...formik.values.incomesAverage, value: "" });
    }
  };

  const clearSave = (value: string) => {
    if (value === NO_SAVING) {
      formik.setFieldValue("saveAverage", { ...formik.values.saveAverage, value: "" });
    }
  };

  const dataModel: Array<FormControlModel> = [
    {
      key: 0,
      formik,
      visible: true,
      name: "additionalIncomes",
      questionData: questions[0],
      label: "¿Tiene ingresos adicionales?",
      elementType: ElementType.Radio,
      onChangeCallback: clearIncomes,
    },
    {
      key: 1,
      formik,
      name: "incomesType",
      label: "¿Qué tipo de ingresos?",
      elementType: ElementType.Checkbox,
      questionData: questions[0]?.subQuestions[0],
      visible: formik?.values?.additionalIncomes?.value === YES,
      checkboxStyle: {
        minWidth: "250px",
        margin: "0 0.5rem",
      },
    },
    {
      key: 2,
      formik,
      type: "number",
      adormentSymbol: "$",
      name: "incomesAverage",
      elementType: ElementType.AdormentTextfield,
      questionData: questions[0]?.subQuestions[1],
      visible: formik?.values?.additionalIncomes?.value === YES,
      label: "¿Cuál es el promedio mensual de estos ingresos?",
    },
    {
      key: 3,
      formik,
      visible: true,
      isRanking: true,
      name: "incomesDestination",
      elementType: ElementType.Checkbox,
      questionData: questions[0]?.subQuestions[2],
      label:
        "¿A qué destina el mayor porcentaje de sus ingresos? (seleccione las tres opciones más relevantes/ importantes para usted).",
      checkboxStyle: {
        minWidth: "325px",
        margin: "0 0.5rem",
      },
    },
    {
      key: 4,
      formik,
      visible: true,
      name: "bankingProducts",
      elementType: ElementType.Checkbox,
      questionData: questions[0]?.subQuestions[3],
      label: "¿Qué productos financieros posee?",
      checkboxStyle: {
        minWidth: "350px",
        margin: "0 0.5rem",
      },
    },
    {
      key: 5,
      formik,
      visible: true,
      name: "isSaveMoney",
      onChangeCallback: clearSave,
      elementType: ElementType.Radio,
      label: "¿Tiene hábito de ahorro?",
      questionData: questions[0]?.subQuestions[4],
    },
    {
      key: 6,
      formik,
      type: "number",
      name: "saveAverage",
      adormentSymbol: "$",
      elementType: ElementType.AdormentTextfield,
      questionData: questions[0]?.subQuestions[5],
      label: "¿Cuál es el promedio mensual de estos ahorros?",
      visible: formik?.values?.isSaveMoney?.value === TRUE,
    },
  ];

  return (
    <div>
      <Typography mb={2} variant='subtitle1' align='left'>
        Seguridad financiera: Ingresos, gastos y ahorros
      </Typography>
      <StepContent>{dataModel.map(FormComponentFactory)}</StepContent>
    </div>
  );
};

export default Step16;
